<template>
  <div>
    <div class="classBnaer">
      <div class="classHead">
        <div class="leftBox"></div>

        <!-- <div>
          <el-input
            type="text"
            size="small"
            v-model="queryParams.certNo"
            style="margin-right: 5px; width: 150px"
            placeholder="请输入证书编号"
            clearable
          ></el-input>
          <el-select
            size="small"
            v-model="queryParams.certType"
            style="width: 150px; margin-right: 5px"
            placeholder="请选择证书类型"
            clearable
          >
            <el-option v-for="item in certNoOptions" :key="item.ID" :label="item.CODE_NAME" :value="item.CODE_NO"> </el-option>
          </el-select>
          <el-date-picker
            size="small"
            style="width: 150px; margin-right: 5px"
            type="year"
            v-model="queryParams.year"
            placeholder="请选择年份"
            value-format="yyyy"
            clearable
          >
          </el-date-picker>
          <el-select
            size="small"
            style="width: 150px; margin-right: 5px"
            v-model="queryParams.receiveType"
            placeholder="请选择领取类型"
            clearable
          >
            <el-option v-for="item in receiveTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>

          <el-button icon="el-icon-search" size="small" type="primary" @click="toCertList"> 搜索 </el-button>
        </div> -->
      </div>

      <div class="list" v-if="showBox">
        <el-table :data="certList" style="width: 100%">
          <el-table-column prop="className" label="班级名称" width="380" align="center"> </el-table-column>
          <!-- <el-table-column prop="CERT_NO" label="证书编号" width="280" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.CERT_TYPE == '0700' && scope.row.YEAR != '2025'">-</div>
              <div v-else>
                {{ scope.row.CERT_NO }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="codeName" label="类型	" align="center">
            <template slot-scope="scope">
              <span style="color: #4077c0">{{ scope.row.codeName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="year" label="年度" align="center"> </el-table-column>
          <el-table-column prop="finishCredit" label="完成学时" align="center">
            <template slot-scope="scope">
              {{ scope.row.finishCredit|| '' }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="PRINT_FLAG"
                           label="打印状态"
                           align="center">
            <template slot-scope="scope">
              <span style="color: #4077C0;" v-if="scope.row.CERT_TYPE !== '0700'">{{ scope.row.PRINT_FLAG == '01' ? '未打印' :'已打印' }}</span>
              <span style="color: #4077C0;" v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRINT_FLAG"
                           label="领取状态"
                           align="center">
            <template slot-scope="scope">
              <span style="color: #4077C0;" v-if="scope.row.CERT_TYPE !== '0700'">{{ scope.row.PRINT_FLAG == '01' ? '未领取' :'已领取' }}</span>
              <span style="color: #4077C0;" v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="RECEIVE_TYPE"
                           label="领取方式	"
                           align="center">
            <template slot-scope="scope">
              <span style="color: #4077C0;" v-if="scope.row.CERT_TYPE !== '0700'">{{ scope.row.RECEIVE_TYPE == '01' ? '自领' : scope.row.RECEIVE_TYPE == '02' ? '代领' : scope.row.RECEIVE_TYPE == '00' ? '未领取' : '' }}</span>
              <span style="color: #4077C0;" v-else>-</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div style="color: #2878ff; cursor: pointer" @click="gox(scope.row)">证书申领</div>
              <!-- <div
                v-if="scope.row.CERT_TYPE == '0700' && scope.row.YEAR != '2025'"
                style="color: #2878ff; cursor: pointer"
                @click="gox(scope.row)"
              >
                证书查看
              </div>
              <a
                v-else
                :href="`/cert?certid=${scope.row.ID}`"
                target="_blank"
                rel="noopener noreferrer"
                style="color: #2878ff; cursor: pointer"
              >
                证书查看
              </a> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="!showBox">
        <div class="group_1">
          <div class="back" @click="showBox = true"><img src="../../../assets/images/back.png" alt="" />返回列表</div>
          <div class="text_1">可将多个学时合并为一个，先选择需要合并的课程，再点击”学时合并“按钮即可完成操作</div>
        </div>
        <div class="group_2">
          <el-table
            ref="multipleTable"
            :data="mergeCourseList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" label="全选" align="center" width="55"> </el-table-column>
            <el-table-column label="课程名称" align="center">
              <template slot-scope="scope">{{ scope.row.courseName }}</template>
            </el-table-column>
            <el-table-column prop="credit" label="完成学时" align="center" width="320"> </el-table-column>
          </el-table>
          <div class="btnBox">
            <el-button class="btn" @click="handleXs">学时合并</el-button>
          </div>
        </div>
        <div class="text_2">已合并列表</div>
        <div class="group_3">
          <el-table
            ref="multipleTable"
            :data="mergeCertList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="证书名称" align="center">
              <template slot-scope="scope">{{ scope.row.certName }}</template>
            </el-table-column>
            <el-table-column prop="year" label="年度" align="center"> </el-table-column>
            <el-table-column prop="credit" label="完成学时" align="center"> </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div style="color: #2878ff; cursor: pointer" @click="goWatch(scope.row)">证书查看</div>
                <div style="color: #2878ff; cursor: pointer" @click="goXX(scope.row)">学时证明</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toCertList, toGetCertType, toMyCertList, getCertApplyList, mergeCredit } from '@/api/study.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      showBox: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      classId: '',
      certList: [], //证书列表
      certNoOptions: [],
      mergeCourseList: [], //待合并学时
      mergeCertList: [], //以合成
      creditSum: 0, //勾选的学时的总计
      creditIds: '' //勾选的学时的总计
      // receiveTypeOptions: [
      //   {
      //     label: '自领',
      //     value: '01'
      //   },
      //   {
      //     label: '代领',
      //     value: '02'
      //   },
      //   {
      //     label: '邮寄',
      //     value: '03'
      //   },
      //   {
      //     label: '现场发放',
      //     value: '04'
      //   },
      //   {
      //     label: '批量邮寄',
      //     value: '05'
      //   }
      // ]
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //公需课证书
    gox(row) {
      this.showBox = false;
      this.classId = row.classId;
      getCertApplyList({ classId: row.classId }).then(res => {
        this.mergeCourseList = res.data.data.mergeCourseList;
        this.mergeCertList = res.data.data.mergeCertList;
      });
    },
        goXX(item) {
     const route =this.$router.resolve({
        path: '/xszm',
        query: {
          classId: item.classId,
          userId: item.userId,
          certId: item.certId,
        }
      });
      window.open(route.href, '_blank');
    },
    // 获取证书列表
    toCertList() {
      toMyCertList(this.queryParams).then(res => {
        this.certList = res.data.rows;
      });
    },
    handleSelectionChange(val) {
      this.creditSum = val.reduce((sum, item) => sum + (item.credit || 0), 0);
      this.creditIds = val.map(item => item.creditId).join(',');
    },
    //去证书页
    goWatch(row) {
      this.$router.push({
        path: '/cert',
        query: {
          id: row.certId
        }
      });
    },
    // 合并学时
    handleXs() {
      if (!this.creditIds) {
        this.$message({
          message: '请先选择要合并的学时',
          type: 'warning',
          duration: 1500
        });
        return;
      }
      this.$confirm('确定合并该学时吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          mergeCredit({ classId: this.classId, creditSum: this.creditSum, creditIds: this.creditIds }).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '学时合并成功',
                type: 'success',
                duration: 800
              });
              getCertApplyList({ classId: this.classId }).then(res => {
                this.mergeCourseList = res.data.data.mergeCourseList;
                this.mergeCertList = res.data.data.mergeCertList;
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
            duration: 800
          });
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.toCertList();
    // toGetCertType().then(res => {
    //   this.certNoOptions = res.data.data;
    // });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */

.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  font-family: Regular;
  .classHead {
    display: flex;
    justify-content: space-between;
    .leftBox {
    }
  }
  .list {
    .m4 {
      margin-top: 4px;
    }
    .s2mDetail {
      overflow: hidden;
      padding-top: 30px;
      min-height: 153px;
      padding-bottom: 25px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      .s2mBg {
        width: 110px;
        height: 90px;
        border-radius: 6px;
      }

      .s2mProd {
        width: 400px;
        margin-left: 10px;
      }

      .rightBox {
        .rightBtn {
          width: 100px;
          height: 34px;
          background: #ffffff;
          border: 1px solid #666666;
          opacity: 1;
          border-radius: 6px;
          font-size: 14px;
          color: #666666;
          text-align: center;
          line-height: 34px;
          margin-bottom: 5px;
          cursor: pointer;
        }
        .xueke {
          border: 1px solid #2878ff !important;
          color: #2878ff !important;
        }
      }
    }
  }
}
.group_1 {
  display: flex;
  justify-content: space-between;
  .back {
    display: flex;
    align-items: center;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.text_1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ff6464;
  text-align: left;
}
.btnBox {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  .btn {
    width: 162px;
    height: 44px;
    background: #ff6464;
    border-radius: 34px 34px 34px 34px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
  }
}
::v-deep {
  .el-table {
    // border: 1px solid #ebeef5;
    // border-bottom: 0;
  }
}
.group_2 {
  border: 1px solid #ebeef5;
  margin-top: 24px;
  padding-bottom: 20px;
}
.text_2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-top: 44px;
}
.group_3 {
  border: 1px solid #ebeef5;
  margin-top: 19px;
  border-bottom: 0;
}
</style>
